import { render, staticRenderFns } from "./index.vue?vue&type=template&id=539ee495&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=539ee495&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ee495",
  null
  
)

export default component.exports